<template>
  <v-select item-title="text" item-value="value" :items="sortItems" variant="outlined" label="Sortierung"
   v-model="internalValue" prepend-inner-icon="mdi-sort" />
  <!--<v-row>
    <v-col class="px-0" v-for="(sort) in value" :key="`${sort[0]}//${sort[1]}`">
      <v-row>
        <v-col cols="8">
          <v-select rounded dense flat v-model="sort[0]" :items="[...sortableFields]" filled />
        </v-col>
        <v-col cols="4">
          <v-select rounded dense v-model="sort[1]" :items="[...SortTypes]" filled />
        </v-col>
      </v-row>
      <v-btn v-if="canMoveSortBackward(i)" @click="moveSortBackward(i)">^</v-btn>
      <v-btn v-if="canMoveSortForward(i)" @click="moveSortForward(i)">v</v-btn>
      <v-btn @click="removeSort(i)">X</v-btn>
    </v-col>
    <v-btn @click="addSort">+</v-btn>
  </v-row>-->
</template>

<script lang="ts">
import {ApiSortOrder} from '@/api/meta/odata';
import {defineComponent, PropType} from 'vue';
export default defineComponent({
  props: {
    modelValue: {
      type: Array as PropType<Array<[string|undefined, ApiSortOrder|undefined]>>,
      required: false,
      default: () => [],
    },
    sortableFields: {
      type: Array as PropType<Array<{text: string; value: string}>>,
      required: false,
      default: () => [],
    },
    SortTypes: {
      type: Array as PropType<Array<{text: string; value: ApiSortOrder}>>,
      required: false,
      default: () => [],
    },
  },
  emits: {
    'update:modelValue': (data: Array<[string|undefined, ApiSortOrder|undefined]>) => Array.isArray(data),
  },
  methods: {
    addSort() {
      const clonedVal = [...this.modelValue];
      clonedVal.push([undefined, this.SortTypes[0].value]);
      this.$emit('update:modelValue', clonedVal);
    },
    removeSort(i: number) {
      (this.modelValue as any[]).splice(i, 1);
      this.$emit('update:modelValue', this.modelValue);
    },
    swapSort(from: number, to: number) {
      const clonedVal = [...this.modelValue];
      const a = clonedVal[from];
      clonedVal[from] = clonedVal[to];
      clonedVal[to] = a;

      this.$emit('update:modelValue', clonedVal);
    },
    canMoveSortForward(i: number) {
      return this.modelValue.length - 1 !== i;
    },
    moveSortForward(i: number) {
      if (!this.canMoveSortForward(i)) throw new Error('Cannot move forward: nowhere to move');
      this.swapSort(i, i + 1);
    },
    canMoveSortBackward(i: number) {
      return i > 0;
    },
    moveSortBackward(i: number) {
      if (!this.canMoveSortBackward(i)) throw new Error('Cannot move backward: nowhere to move');
      this.swapSort(i, i - 1);
    },
  },
  computed: {
    sortItems() {
      const sortItems: any[] = [];
      this.sortableFields.forEach((field: any) => {
        this.SortTypes.forEach((type: any) => {
          sortItems.push({
            text: `${field.text} ${type.text}`,
            value: `${field.value}//${type.value}`,
          });
        });
      });
      return sortItems;
    },
    internalValue: {
      set(newVal: string) {
        const [field, type] = (newVal ?? '').split('//') as [string | undefined, ApiSortOrder | undefined];
        let data: Array<[string|undefined, ApiSortOrder|undefined]>;
        if (field === undefined || type === undefined) {
          data = [];
        } else {
          data = [
            [field, type],
          ];
        }

        this.$emit('update:modelValue', data);
      },
      get() {
        if (!this.modelValue.length) return undefined;
        const [field, type] = (this.modelValue as Array<[string, string]>)[0];

        return `${field}//${type}`;
      },
    },
  },
});
</script>
<style scoped>
  .v-input__slot {
    border-bottom-right-radius: 0;
  }
</style>
